import axios from "axios";
import axiosInstance from "../server/axios"

export const fatchTypeOffers=(search,limit,page)=>{
    const token = localStorage.getItem('authToken');
    console.log(token);
    return axiosInstance.get(`/types`, {
      params: { search, page, limit },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
    });
}

export const addTypeOffer=(data)=>{
    const token = localStorage.getItem('authToken');
    return axios.post(`https://api.masterfut.com/api/types`, data, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        }
    });
}

export const editTypeOffer=(id,data)=>{
    const token = localStorage.getItem('authToken');
    return axiosInstance.put(`/types/${id}`, data, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        }
    });
}

export const deleteTypeOffer=(id)=>{
    const token = localStorage.getItem('authToken');
    return axiosInstance.delete(`/types/${id}`, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        }
    });
}
